import React from "react";
import Weather from "./Weather"
import './App.css';

function App() {
  return (
    <div className="App">
      <div className='container'>
       
        <Weather defaultCity ="Lagos"/>
        <footer>
          This project was coded by Francisca
          and is {""}
         <a href='https://github.com/Cisca-ella/react-weather-app' rel="noreferrer" target='_blank'> 
         open sourced on Github</a> {""} and hosted on <a href='https://react-weather-app-self-three.vercel.app/' rel="noreferrer" target="_blank" >Vercel</a>
       </footer>
      </div>
      
    </div>
  );
}

export default App;
